'use client'

import InlineVideo from '@hashicorp/react-components/src/components/inline-video'
import s from './BlogVideo.module.css'

export default function BlogVideo({ url, description }) {
	return (
		<section className={s.videoContainer}>
			<InlineVideo
				url={url}
				description={description}
				gradientPosition={false}
			/>
		</section>
	)
}
